import { useRef } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryCards() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-background-50/80 border border-background-50/20 rounded-full mb-4">
              All Categories
            </span>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              Shop By{" "}
              <span className="italic text-primary-400">Category</span>
            </h2>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll("left")}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-50/20 text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-background-50/20 text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-48 md:w-56 snap-start group cursor-pointer"
            >
              <div className="aspect-square rounded-2xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-sm font-bold text-background-50 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-background-50/50 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                Explore &rarr;
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}